import { Building2, ShieldCheck, UserPlus, Users } from 'lucide-react'
import { StatCard } from '~/components/StatCard'

// 상단 KPI 행 — 총 사용자·가입 신청·관리자·조직 수.
export function UsersKpiRow({
    total,
    pendingCount,
    adminCount,
    hasOrg,
    orgs,
}: {
    total: number
    pendingCount: number
    adminCount: number
    hasOrg: boolean
    orgs: Set<string>
}) {
    return (
        <div className='mb-4 grid grid-cols-2 gap-4 lg:grid-cols-4'>
            <StatCard label='총 사용자' value={total} icon={Users} />
            <StatCard
                label='가입 신청'
                value={pendingCount}
                icon={UserPlus}
                tone={pendingCount > 0 ? 'warning' : 'default'}
                hint={pendingCount > 0 ? '승인 대기 중' : '대기 중인 신청 없음'}
            />
            <StatCard
                label='관리자'
                value={adminCount}
                icon={ShieldCheck}
                tone='warning'
                hint='admin · superadmin'
            />
            <StatCard
                label='조직'
                value={hasOrg ? orgs.size : '-'}
                icon={Building2}
                hint={hasOrg ? '소속 조직 수' : '조직 정보 없음'}
            />
        </div>
    )
}
